import Phaser from 'phaser';

export class GameHUD {
  private scene: Phaser.Scene;
  private container: Phaser.GameObjects.Container;
  private turnText: Phaser.GameObjects.Text;
  private coinsText: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    const width = scene.cameras.main.width;

    this.container = scene.add.container(0, 0);

    // Top Bar
    const bg = scene.add.graphics();
    bg.fillStyle(0x000000, 0.6);
    bg.fillRect(0, 0, width, 50);
    this.container.add(bg);

    this.coinsText = scene.add.text(width / 2, 25, 'Monedas: 0', {
        fontSize: '18px',
        color: '#d4af37'
    }).setOrigin(0.5);
    this.container.add(this.coinsText);

    this.turnText = scene.add.text(width / 2, 80, '', {
        fontSize: '24px',
        color: '#ffffff',
        fontStyle: 'bold'
    }).setOrigin(0.5);
    this.container.add(this.turnText);
  }

  updateCoins(amount: number) {
    this.coinsText.setText(`Monedas: ${amount}`);
  }

  updateTurn(playerName: string, isHuman: boolean) {
    this.turnText.setText(isHuman ? '🟢 Tu turno' : `🔴 Turno de ${playerName}...`);
    this.scene.tweens.add({
        targets: this.turnText,
        alpha: { start: 1, end: 0.5 },
        duration: 800,
        yoyo: true,
        repeat: -1
    });
  }

  updateXP(xp: number, maxXp: number) {
    // XP update logic placeholder
  }
}
